import { render, staticRenderFns } from "./BroiLica.vue?vue&type=template&id=688ac232"
import script from "./BroiLica.vue?vue&type=script&lang=js"
export * from "./BroiLica.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports